"use client"

import { useAppContext } from '@/helpers/context/AppContext';
import React from "react"
import { Container, Image, Navbar } from "react-bootstrap"

export default function NavbarLanding() {
    const context = useAppContext();

    const langHandler = () => {
        if (context.lang === 1){
            context.setLang(2)
        } else {
            context.setLang(1)
        }
    }

    return (
        <Navbar fixed="top" className='navbar-landing'>
            <Container className='justify-content-end'>
                <div className='lang-container shadow mt-3' onClick={langHandler}>
                    <p className={`btn-lang lang-id ${context.lang === 1 ? 'active' : ''}`}>IND</p>
                    <p className='text-gold mx-2 mb-0'>|</p>
                    <p className={`btn-lang lang-en ${context.lang === 1 ? '' : 'active'}`}>ENG</p>
                </div>
            </Container>
        </Navbar>
    )
  
}
